import {APIRequest} from "./APIRequest.js";
import {WebTools} from "../constants";
import {signKBTransactionJWT} from "../Crypto/utils";

export const docToTextAPI = async (selectedFile, setSystemAlert, KB) => {
    try {
        const mimeType = selectedFile.type || 'application/octet-stream';

        const fileReader = new FileReader();
        const fileData = await new Promise((resolve, reject) => {
            fileReader.onload = () => resolve(fileReader.result);
            fileReader.onerror = reject;
            fileReader.readAsArrayBuffer(selectedFile);
        });

        if (selectedFile.size > 6000000){
            setSystemAlert({msg: "Upload Failed: The file exceeds the maximum limit of 6MB.", type: 'error', duration: 10000});
            return;
        }

        const transactionJWT = await signKBTransactionJWT({
            toAccountId: WebTools["documentToText"]?.accountId,
            ...KB,
            message: '',
            maxAmount: 10000
        })

        const response = await APIRequest('post', WebTools["documentToText"].url + `?method=fromBufferWithMime`, fileData, {
            headers: {
                'Content-Type': mimeType,
                'filename': selectedFile.name,
                'transaction-jwt' : transactionJWT
            }
        });

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        setSystemAlert({msg: "Upload Failed!", type: 'error', duration: 3000});
    }
};
